<script lang="ts">
    import type { Merge } from 'type-fest';
    import type { HTMLAttributes } from 'svelte/elements';
    import highlightWords from 'highlight-words';

    export let text: string = '';
    export let query: string | null | undefined = null;
    export let highlightClass: string = '';
    export let unhighlightClass: string = '';

    let chunks = query == null ? null : highlightWords({ text, query });
    $: chunks = query == null ? null : highlightWords({ text, query });

    type $$Props = Merge<
        HTMLAttributes<HTMLElement>,
        {
            text: string;
            query: string | null | undefined;
            highlightClass: string;
            unhighlightClass?: string;
        }
    >;
</script>

{#if chunks != null}
    <p {...$$restProps} aria-label={text}>
        {#each chunks as chunk (chunk.key)}
            <span
                aria-hidden={true}
                class={chunk.match ? highlightClass : unhighlightClass}>{chunk.text}</span
            >
        {/each}
    </p>
{:else}
    <p {...$$restProps}>{text}</p>
{/if}
